<router-outlet></router-outlet>

<!-- <style>
    .sr-no {
        margin-right: 5px;
    }


    .option-th {
        width: 100px;
        height: 40px;
        text-align: center;
    }

    .hide-th {
        display: none;
    }

    textarea {
        width: 100%;
    }

    th,
    td {
        height: 40px;
    }

    .sub-ques th {
        display: none;
    }

    .sub-ques td {
        padding-left: 20px;
    }
</style>

<div class="" *ngFor="let surveyForm of surveyFormArr;let i=index">
    <h6 class="bg-dark text-white">{{surveyForm.catName}}</h6>
    <div>
        <table>
            <thead>
                <tr>
                    <th class="hide-th"></th>
                    <th class="hide-th"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let ques of surveyForm.question; let i=index">
                    <td class="ques">
                        <span class="sr-no">{{i+1}}.</span>{{ques.question}}
                        <ng-container *ngIf="ques.subQuestion?.length">
                            <table class="sub-ques">
                                <thead>
                                    <tr>
                                        <th class="hide-th"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let subQues of ques.subQuestion">
                                        <td>{{subQues.subQuestion}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </ng-container>
                    </td>
                    <td>
                        <ng-container *ngIf="ques.questionType==2">
                            <textarea class="form-control"></textarea>
                        </ng-container>

                        <ng-container *ngIf="ques.questionType==1">
                            <table>
                                <thead>
                                    <tr>
                                        <th class="option-th" *ngFor="let option of ques.options">{{option.name}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td *ngFor="let option of ques.options" class="text-center">
                                            <input class="form-check-input" type="radio">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </ng-container>

                        <ng-container *ngIf="ques.questionType==3">
                            <table>
                                <thead>
                                    <tr>
                                        <th class="option-th" *ngFor="let option of ques.options">{{option.name}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let option of ques.subQuestion">
                                        <td *ngFor="let option of ques.options" class="text-center">
                                            <input class="form-check-input" type="radio">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </ng-container>

                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div> -->